import { IconProps } from "../interface";
import { IconColours } from "../interface";
const Play = ({
    size,
    className,
    title = "play",
    ariaHidden,
    type,
    colour = IconColours.black,
    secondaryColour = IconColours.white,
}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width={size}
        height={size}
        viewBox="0 -960 960 960"
        role="img"
        aria-hidden={ariaHidden}
        focusable={!ariaHidden}
    >
        <title>{title}</title>
        {type === "outlined" && (
            <circle cx="480" cy="-480" r="480" fill={secondaryColour} />
        )}
        <path
            data-testid="path"
            d="M320-273v-414q0-17 12-28.5t28-11.5q5 0 10.5 1.5T381-721l326 207q9 6 13.5 15t4.5 19q0 10-4.5 19T707-446L381-239q-5 3-10.5 4.5T360-233q-16 0-28-11.5T320-273Z"
            fill={colour}
        />
    </svg>
);

export default Play;
